import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 53 52",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.75 11.9167L12.1667 6.5L26.25 20.5833L40.3333 6.5L45.75 11.9167L31.6667 26L45.75 40.0833L40.3333 45.5L26.25 31.4167L12.1667 45.5L6.75 40.0833L20.8333 26L6.75 11.9167Z",
      fill: "#FF6761",
      stroke: "#FF6761",
      "stroke-width": "1.83333",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }